function noop() {}
var localStorageManager = function localStorageManager(_ref) {
  var key = _ref.key,
    storageWindow = _ref.storageWindow;
  if (!storageWindow && typeof window !== 'undefined') {
    storageWindow = window;
  }
  return {
    get: function get(defaultValue) {
      if (typeof window === 'undefined') {
        return undefined;
      }
      if (!storageWindow) {
        return defaultValue;
      }
      var value;
      try {
        value = storageWindow.localStorage.getItem(key);
      } catch (_unused) {
        // Unsupported
      }
      return value || defaultValue;
    },
    set: function set(value) {
      if (storageWindow) {
        try {
          storageWindow.localStorage.setItem(key, value);
        } catch (_unused2) {
          // Unsupported
        }
      }
    },
    subscribe: function subscribe(handler) {
      if (!storageWindow) {
        return noop;
      }
      var listener = function listener(event) {
        var value = event.newValue;
        if (event.key === key) {
          handler(value);
        }
      };
      storageWindow.addEventListener('storage', listener);
      return function () {
        storageWindow.removeEventListener('storage', listener);
      };
    }
  };
};
export default localStorageManager;